<template>
  <div class="post-counters" v-if="post.network_name !== hideSocialForNetwork">

    <img class="counter-header__icon" v-if="post.network_name === 'vk'" src="../../../../assets/images/icon-vk.svg">
    <img class="counter-header__icon" v-if="post.network_name === 'fb'" src="../../../../assets/images/icon-fb.svg">
    <img class="counter-header__icon" v-if="post.network_name === 'tw'" src="../../../../assets/images/icon-tw.svg">
    <img class="counter-header__icon" v-if="post.network_name === 'gs'" src="../../../../assets/images/icon-smi.svg">

    <div class="post-counter__item">
      <img class="post-counter__item-icon" src="../../../../assets/images/icon-counter-view.svg">
      <div class="post-counter__item-count">{{ post.viewed }}</div>
    </div>
    <div class="post-counter__item">
      <img class="post-counter__item-icon" src="../../../../assets/images/icon-counter-like.svg">
      <div class="post-counter__item-count">{{ post.likes }}</div>
    </div>
    <div class="post-counter__item">
      <img class="post-counter__item-icon" src="../../../../assets/images/icon-counter-comment.svg">
      <div class="post-counter__item-count">{{ post.comments }}</div>
    </div>
    <div class="post-counter__item">
      <img class="post-counter__item-icon" src="../../../../assets/images/icon-counter-share.svg">
      <div class="post-counter__item-count">{{ post.reposts }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'postCounters',
    data() {
      return {
        hideSocialForNetwork: 'gs',
      };
    },
    props: {
      post: {
        type: Object,
        default() {
          return {};
        },
      },
    },
  };
</script>

<style scoped>
  .post-counters {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px 15px;
    box-sizing: border-box;
    border-top: 1px solid #e5e5e5;
  }

  .post-body .post-counters {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
  }

  .post-counter__item {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .post-counter__item:last-child {
    margin-right: 0;
  }

  .post-counter__item-icon {
    margin-right: 5px;
  }

  .post-counter__item-count {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: normal;

    color: #55626F;
  }
  .counter-header__icon {
    position: relative;
    margin: 0 20px 0 -18px;
  }
</style>
